export const psychologistReportSteps = {
  etiologyProblem: 'etiologyProblem',
  disorders: 'disorders',
  reportObservations: 'reportObservations',
} as const;

const supporterReportSteps = {
  issueType: 'issueType',
  reportObservations: 'reportObservations',
} as const;

export const chatReportSteps = {
  ...psychologistReportSteps,
  ...supporterReportSteps,
} as const;

export const StepComponentTypes = {
  radio: 'radio',
  checkbox: 'checkbox',
  textarea: 'textarea',
} as const;
